// @ts-strict-ignore

export enum PaymentStatus {
  CANCELED = 'Canceled',
  PAID = 'Paid',
  PROCESSING = 'Processing',
  PENDING = 'Pending Info',
}

export const getPaymentStatus = (payment) => {
  if (payment.canceled) {
    return PaymentStatus.CANCELED;
  }
  if (payment.has_paid_publisher) {
    return PaymentStatus.PAID;
  }
  if (payment.is_payable) {
    return PaymentStatus.PROCESSING;
  }
  return PaymentStatus.PENDING;
};

export enum BriefPaymentStatus {
  PAID = 'Paid',
  PARTIALLY_PAID = 'Partially Paid',
  PENDING = 'Pending',
}
